import * as React from "react";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = React.forwardRef<HTMLButtonElement, Props>(
  ({ className = "", ...rest }, ref) => (
    <button
      ref={ref}
      className={
        // No default bg/text; caller controls it.
        "inline-flex items-center justify-center rounded-full px-3 py-1.5 text-sm font-medium " +
        "transition-colors disabled:opacity-50 " +
        className
      }
      {...rest}
    />
  )
);
Button.displayName = "Button";
